import React, { createContext, useMemo, useState } from "react";
import { FlagProvider } from "@unleash/proxy-client-react";
import { getFlagsClient } from "../singleton";

type Props = {
  applicationName: string;
  children?: React.ReactNode;
};

export interface ContextProps {
  arenaId: string;
  setArenaId: (id: string) => void;
}

export const ArenaContext = createContext<ContextProps | undefined>(undefined);

export function FeatureFlagProvider({ children, applicationName }: Props) {
  const unleashClient = getFlagsClient(applicationName);
  const [arenaId, setArenaId] = useState<string>("");

  // if we could not resolve the client, we should not start it
  const shouldClientStart = useMemo(() => unleashClient !== undefined, [unleashClient]);

  const arenaProviderContext = useMemo(() => ({ arenaId, setArenaId }), [arenaId, setArenaId]);

  return (
    <FlagProvider unleashClient={unleashClient} startClient={shouldClientStart}>
      <ArenaContext.Provider value={arenaProviderContext}>{children}</ArenaContext.Provider>
    </FlagProvider>
  );
}
